export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'
export const ADD = 'ADD'
export const FETCH = 'FETCH'
export const FETCH_ONE = 'FETCH_ONE'
